import { render, staticRenderFns } from "./VideoLike.vue?vue&type=template&id=0b6d04d2&scoped=true&"
import script from "./VideoLike.vue?vue&type=script&lang=js&"
export * from "./VideoLike.vue?vue&type=script&lang=js&"
import style0 from "./VideoLike.vue?vue&type=style&index=0&id=0b6d04d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6d04d2",
  null
  
)

export default component.exports